/*--------------------------------------------------------------
# Custom scripts for template
--------------------------------------------------------------*/

// get section height divide by 2 and minus half height of shape
// add above calc value as top value CSS

// Wait until the document is fully loaded
document.addEventListener('DOMContentLoaded', function () {
    const accordionItemsToBeFocused = document.querySelectorAll('.accordion-collapse');

    accordionItemsToBeFocused.forEach((el) => {
        el.addEventListener('shown.bs.collapse', () => {
            setTimeout(() => {
                const header = el.previousElementSibling;
                const accordionItem = el.closest('.accordion-item');

                if (header && accordionItem) {
                    const rect = accordionItem.getBoundingClientRect();
                    const fullyInView = rect.top >= 0 && rect.bottom <= window.innerHeight;

                    // Only scroll if not fully in view
                    if (!fullyInView) {
                        // Use 210px for mobile, 90px for desktop
                        const offset = window.innerWidth < 768 ? 210 : 163;

                        const headerOffset = header.getBoundingClientRect().top + window.scrollY - offset;

                        window.scrollTo({
                            top: headerOffset,
                            behavior: 'smooth'
                        });
                    }
                }
            }, 350); // Delay matches Bootstrap's collapse transition
        });
    });
});
